enum EDefaultRoutePath {
  HOME = '/',
  COOPERATION_REFUSED = '/cooperation-refused',
  NOT_FOUND_PAGE = '/:pathMatch(.*)*',
}

export default EDefaultRoutePath;
